<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-dropdown-docs-preview></ui-dropdown-docs-preview></p>
<h1 id="description">Description</h1>
<p>Dropdown</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span> <span class="hljs-attr">text</span>=<span class="hljs-string">"Open dropdown"</span> [<span class="hljs-attr">uiDropdownTarget</span>]=<span class="hljs-string">"dropdown1"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-dropdown</span>
    #<span class="hljs-attr">dropdown1</span>
    <span class="hljs-attr">header</span>=<span class="hljs-string">"Header"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-dropdown-item</span> (<span class="hljs-attr">click</span>)=<span class="hljs-string">"onClick('Item 1')"</span>&gt;</span>Item 1<span class="hljs-tag">&lt;/<span class="hljs-name">ui-dropdown-item</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-dropdown-item</span> (<span class="hljs-attr">click</span>)=<span class="hljs-string">"onClick('Item 2')"</span>&gt;</span>Item 2<span class="hljs-tag">&lt;/<span class="hljs-name">ui-dropdown-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-dropdown</span>&gt;</span>
</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">header</td>
<td align="left">&#64;summary:<br/> Optional header for the dropdown list</td>
</tr>
<tr>
<td align="left">width</td>
<td align="left">&#64;summary:<br/> Width of the dropdown</td>
</tr>
<tr>
<td align="left">maxHeight</td>
<td align="left">&#64;summary:<br/> MaxHeight of the dropdown</td>
</tr>
<tr>
<td align="left">useTargetWidth</td>
<td align="left">&#64;summary:<br/> Use the target&#39;s width</td>
</tr>
<tr>
<td align="left">type</td>
<td align="left">&#64;summary:<br/> The type of dropdown</td>
</tr>
<tr>
<td align="left">offset</td>
<td align="left">&#64;summary:<br/> Position offset of the dropdown</td>
</tr>
<tr>
<td align="left">positions</td>
<td align="left">&#64;summary:<br/> Positions overrides on the popover used by the dropdown</td>
</tr>
<tr>
<td align="left">theme</td>
<td align="left">&#64;summary:<br/> Overriding theme</td>
</tr>
<tr>
<td align="left">minWidth</td>
<td align="left">&#64;summary The dropdowns minimum width</td>
</tr>
<tr>
<td align="left">hasBackdrop</td>
<td align="left">&#64;summary If the dropdown should have a backdrop. Disabling this requires you to close the dropdown manually</td>
</tr>
<tr>
<td align="left">disabled</td>
<td align="left">&#64;summary Disables the possiblity to open the dropdown</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
